export default function RawOverlay(google, map, floor) {
  gm.prototype = new google.maps.OverlayView()

  function gm(map, floor) {
    this.map = map
    this.floor = floor
    this.div_ = null
    this.setMap(map)
  }

  gm.prototype.onAdd = function () {
    this.div_ = document.createElement("div");
    this.div_.style.borderStyle = "none";
    this.div_.style.borderWidth = "0px";
    this.div_.style.position = "absolute";
    this.div_.style.transform = 'rotate(' + this.floor.floor_angle + 'deg)'

    // Create the img element and attach it to the div.
    const img = document.createElement("img");

    const opacity = this.floor.floor_opacity / 100
    img.style.opacity = opacity < 0.7 ? 0.7 : opacity

    let imgUrl = this.floor.floor_file
    if (!imgUrl) {
      // this.div_.classList.add('outdoor-building--floor--no-img')
      imgUrl = '/blank.png'
      img.style.backgroundColor = "#FF0000";
      img.style.opacity = 0.2
    }

    img.id = this.floor._id;
    img.src = imgUrl;
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.position = "absolute";

    this.div_.appendChild(img);

    // Add the element to the "overlayLayer" pane.
    const panes = this.getPanes();

    panes.overlayLayer.appendChild(this.div_);
  }

  gm.prototype.draw = function () {
    // We use the south-west and north-east
    // coordinates of the overlay to peg it to the correct position and size.
    // To do this, we need to retrieve the projection from the overlay.
    const bounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(this.floor.floor_sw_lat, this.floor.floor_sw_lon),
      new google.maps.LatLng(this.floor.floor_ne_lat, this.floor.floor_ne_lon)
    )

    const overlayProjection = this.getProjection();

    // Retrieve the south-west and north-east coordinates of this overlay
    // in LatLngs and convert them to pixel coordinates.
    // We'll use these coordinates to resize the div.
    const sw = overlayProjection.fromLatLngToDivPixel(bounds.getSouthWest())
    const ne = overlayProjection.fromLatLngToDivPixel(bounds.getNorthEast())

    // Resize the image's div to fit the indicated dimensions.
    if (this.div_) {
      this.div_.style.left = sw.x + "px";
      this.div_.style.top = ne.y + "px";
      this.div_.style.width = ne.x - sw.x + "px";
      this.div_.style.height = sw.y - ne.y + "px";

      if (!this.floor.floor_file) {
        this.div_.style.border = "2px solid #FF0000"
      }
    }
  }

  gm.prototype.onRemove = function () {
    if (this.div_) {
      this.div_.parentNode.removeChild(this.div_);
      this.div_ = null;
    }
  }

  return new gm(map, floor)
}
